export default __webpack_public_path__ + "static/media/starwars.11c3ef69.JPG";